declare namespace $ {

	type $mol_button_major__title_brand_app_example_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__title_brand_app_example_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__enabled_brand_app_example_3 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_minor__title_brand_app_example_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_brand_app_example_5 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $brand_app_example_section__title_brand_app_example_6 = $mol_type_enforce<
		string
		,
		ReturnType< $brand_app_example_section['title'] >
	>
	type $brand_app_example_section__content_brand_app_example_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $brand_app_example_section['content'] >
	>
	type $mol_number__hint_brand_app_example_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_number['hint'] >
	>
	type $mol_string__hint_brand_app_example_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_brand_app_example_10 = $mol_type_enforce<
		ReturnType< $brand_app_example['string_content'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $brand_app_example_section__title_brand_app_example_11 = $mol_type_enforce<
		string
		,
		ReturnType< $brand_app_example_section['title'] >
	>
	type $brand_app_example_section__content_brand_app_example_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $brand_app_example_section['content'] >
	>
	type $mol_check_box__title_brand_app_example_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__title_brand_app_example_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_brand_app_example_15 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__title_brand_app_example_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__enabled_brand_app_example_17 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_check_box['enabled'] >
	>
	type $mol_switch__value_brand_app_example_18 = $mol_type_enforce<
		ReturnType< $brand_app_example['color'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_brand_app_example_19 = $mol_type_enforce<
		ReturnType< $brand_app_example['colors'] >
		,
		ReturnType< $mol_switch['options'] >
	>
	type $brand_app_example_section__title_brand_app_example_20 = $mol_type_enforce<
		string
		,
		ReturnType< $brand_app_example_section['title'] >
	>
	type $brand_app_example_section__content_brand_app_example_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $brand_app_example_section['content'] >
	>
	type $mol_link__title_brand_app_example_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_brand_app_example_23 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link_iconed__uri_brand_app_example_24 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link_iconed['uri'] >
	>
	type $brand_app_example_section__title_brand_app_example_25 = $mol_type_enforce<
		string
		,
		ReturnType< $brand_app_example_section['title'] >
	>
	type $brand_app_example_section__content_brand_app_example_26 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $brand_app_example_section['content'] >
	>
	type $brand_app_example_section__title_brand_app_example_27 = $mol_type_enforce<
		string
		,
		ReturnType< $brand_app_example_section['title'] >
	>
	type $brand_app_example_section__content_brand_app_example_28 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $brand_app_example_section['content'] >
	>
	export class $brand_app_example extends $mol_page {
		Lighter( ): $mol_lights_toggle
		Button_major( ): $mol_button_major
		Button_major_disabled( ): $mol_button_major
		Button_minor( ): $mol_button_minor
		Button_minor_disabled( ): $mol_button_minor
		Buttons( ): $brand_app_example_section
		Number( ): $mol_number
		String( ): $mol_string
		string_content( next?: string ): string
		String_content( ): $mol_string
		Inputs( ): $brand_app_example_section
		Checkbox( ): $mol_check_box
		Checkbox_checked( ): $mol_check_box
		Checkbox_disabled( ): $mol_check_box
		color( next?: string ): string
		colors( ): ({ 
			'red': string,
			'green': string,
			'blue': string,
		}) 
		Switcher( ): $mol_switch
		Checkboxes( ): $brand_app_example_section
		Link( ): $mol_link
		Link_uri( ): $mol_link
		Link_iconed( ): $mol_link_iconed
		Links( ): $brand_app_example_section
		Icon_github( ): $mol_icon_github_circle
		Icons( ): $brand_app_example_section
		title( ): string
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
	}
	
	type $mol_text__text_brand_app_example_section_1 = $mol_type_enforce<
		ReturnType< $brand_app_example_section['title'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_list__rows_brand_app_example_section_2 = $mol_type_enforce<
		ReturnType< $brand_app_example_section['content'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	export class $brand_app_example_section extends $mol_list {
		title( ): string
		Section( ): $mol_text
		content( ): readonly(any)[]
		Content( ): $mol_list
		rows( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=example.view.tree.d.ts.map